import React from "react";

const Footer = () => (
  <footer className="bg-black text-white text-center py-3">
    &copy; {new Date().getFullYear()} AirGrid. All rights reserved.
  </footer>
);

export default Footer;
